<script setup>
import {Chart as highcharts} from "highcharts-vue"
import {onMounted, reactive, ref, inject, watch} from "vue";
import mapOptions from "@/views/market/sectorsMapOptions";
import constants from "@/constants/constants";
import exportingInit from "highcharts/modules/exporting";
import Highcharts from "highcharts";
import addTreemapModule from "highcharts/modules/treemap";
import dashboardService from "@/services/dashboard.service";

typeof exportingInit === 'function' && exportingInit(Highcharts);
typeof addTreemapModule === 'function' && addTreemapModule(Highcharts);
Highcharts.AST.allowedAttributes.push('onclick');

window.chartClicked = function(event, node) {
    event.stopPropagation();
    chartClicked(node);
};

const currentSubsector = inject('currentSubsector');
const currentSector = inject('currentSector');

const chartOptions = reactive(mapOptions);
const loading = ref(false);

watch(currentSector, () => {
    getData();
}, {deep: true});

onMounted(() => {
    getData();
});

function chartClicked(node) {
    currentSubsector.value = {
        id: node.id,
        name: node.name
    };
}

async function getData() {
    const {data} = await dashboardService.getChartData('MarketSectorsMap', {sector_id : currentSector.value.id});
    chartOptions.series[0].data = data;

    chartOptions.series[0].events = {
        click: (e) => {
            chartClicked(e.point.node);
        }
    }
}
</script>

<template>
    <div class="position-relative">
        <highcharts
            v-if="!loading"
            ref="chart"
            :options="chartOptions"
            style="min-height:500px;border-radius: 8px;"
        />

        <div v-else class="d-flex justify-content-center">
            <b-spinner :style="{'color':constants.spinnerColor}"></b-spinner>
        </div>
    </div>
</template>

<style scoped>

</style>
